import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { ProductCard } from './ProductCard';
import { ProductGridSkeleton } from '../skeleton/ProductGridSkeleton';
import { GridBanner } from './GridBanner';
import styles from './ProductGrid.module.scss';
import { expandProductsByColourVariants } from '../../utils/productVariantExpander';
import AppConfig from '../../config/config';
import { initReviewsIoRatingSnippets } from '../../utils/reviewsIoRatingSnippet';
export function ProductGrid({ products, loading, layout, bannerConfig }) {
    const displayProducts = AppConfig.enableColourSwatch
        ? products
        : expandProductsByColourVariants(products);
    const reviewsIoRenderKey = displayProducts
        .map((product) => product.id)
        .join('|');
    useEffect(() => {
        if (!loading && displayProducts.length > 0) {
            initReviewsIoRatingSnippets();
        }
    }, [loading, reviewsIoRenderKey, layout.cardLayout, layout.filterLayout]);
    if (loading) {
        return h(ProductGridSkeleton, { count: 9, layout: layout });
    }
    // Determine the grid class based on card layout
    let layoutClass = '';
    switch (layout.cardLayout) {
        case 'gridTwo':
            layoutClass = styles.productGridTwo;
            break;
        case 'gridThree':
            layoutClass = styles.productGridThree;
            break;
        case 'gridFour':
            layoutClass = styles.productGridFour;
            break;
        case 'list':
            layoutClass = styles.productList;
            break;
        default:
            layoutClass = styles.productGridThree;
    }
    // Apply filter layout adjustments only for grid layouts with side filter
    const needsFilterAdjustment = layout.filterLayout === 'filterSide' &&
        (layout.cardLayout === 'gridFour' || layout.cardLayout === 'gridThree' || layout.cardLayout === 'gridTwo');
    const finalClassName = needsFilterAdjustment
        ? `${layoutClass} ${styles.productGridFourWithSideFilter}`
        : layoutClass;
    const bannerAt = bannerConfig ? Math.max(0, bannerConfig.position - 1) : -1;
    const items = [];
    products.forEach((product, i) => {
        if (bannerConfig && i === bannerAt) {
            items.push(h(GridBanner, { key: "banner", config: bannerConfig, class: bannerConfig.isWide ? styles.gridBannerWide : undefined }));
        }
        items.push(h(ProductCard, { key: product.id, product: product, layout: layout.cardLayout }));
    });
    if (bannerConfig && bannerAt >= products.length) {
        items.push(h(GridBanner, { key: "banner", config: bannerConfig, class: bannerConfig.isWide ? styles.gridBannerWide : undefined }));
    }
    return (h("div", { class: finalClassName, "data-layout": layout.cardLayout, "data-filter-layout": layout.filterLayout }, displayProducts.map(product => (h(ProductCard, { key: product.id, product: product, layout: layout.cardLayout })))));
}
